<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.AFFILIATION.OPEN"
    :handler="() => $refs.modal.show()"
  />
  <DialogComponent ref="modal" type="fullscreen" hideCloseButton noInnerPadding>
    <div class="h-full flex flex-col overflow-auto">
      <!-- header -->
      <div class="p-5 md:p-6">
        <FullScreenDialogHeader @backClicked="() => $refs.modal.hide()">
          Parrainage
        </FullScreenDialogHeader>
      </div>

      <!-- main content with max width on desktop -->
      <div class="px-5 md:px-6 pb-6">
        <div class="max-w-4xl mx-auto">
          <!-- invite card -->
          <div class="p-5 md:p-8 bg-white rounded-3xl md:rounded-4xl shadow-sm">
            <div
              class="title-color text-2xl md:text-3xl font-semibold mb-3 md:mb-4"
            >
              Invite tes amis & gagne jusqu'à 100.000 CFA
            </div>
            <div class="description-color text-sm md:text-base mb-5 md:mb-6">
              Pour chaque invité, tu gagnes un bénéfice de 5% pour tous leurs
              dépôts. Ce qui te fait <span class="font-bold">500 CFA</span> de
              gain s'ils font des dépôts de
              <span class="font-bold">10.000 CFA</span>
            </div>

            <!-- referral code -->
            <div
              class="bg-[#EFEFFE] rounded-xl flex items-center justify-between p-2 md:p-3 mb-5 md:mb-6 gap-3"
            >
              <div
                class="font-bold text-xl md:text-2xl title-color px-2 md:px-3"
              >
                44BB23
              </div>
              <button
                class="buttonComponent small py-2 md:py-3 px-3 md:px-4 flex items-center gap-2 text-sm md:text-base whitespace-nowrap"
              >
                <span class="hidden md:inline">Copier mon code</span>
                <span class="md:hidden">Copier</span>
                <ColorImg
                  src="/images/icons/copy.svg"
                  class="bg-current w-5 h-5 md:w-6 md:h-6"
                />
              </button>
            </div>

            <!-- share button -->
            <button
              class="buttonComponent py-4 md:py-5 items-center gap-2 w-full rounded-full text-base md:text-lg font-semibold"
              v-bus:EVENTS.AFFILIATION.REQUEST_LINK_SHARING.click
            >
              Partager mon lien de parrainage
            </button>
          </div>
        </div>
      </div>

      <!-- earnings section -->
      <div class="bg-white flex-1 mt-6 md:mt-8">
        <div class="max-w-4xl mx-auto">
          <div class="p-4 md:p-6">
            <!-- earnings card -->
            <div class="rounded-3xl bg-[#ffaa64] p-4 md:p-6">
              <div
                class="rounded-full bg-white/40 p-2 md:p-3 w-min whitespace-nowrap text-sm md:text-base font-bold px-4 md:px-6"
              >
                Gains (Parrainage)
              </div>
              <div class="py-6 md:py-8"></div>
              <div
                class="px-2 flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-6"
              >
                <div class="text-center md:text-left">
                  <div class="text-3xl md:text-4xl lg:text-5xl font-bold">
                    0 CFA
                  </div>
                  <div class="text-white/80 text-sm md:text-base mt-1">
                    Total disponible
                  </div>
                </div>
                <div class="flex md:flex-shrink-0">
                  <button class="buttonComponent small w-full md:w-auto">
                    Retirer
                  </button>
                </div>
              </div>
            </div>
            <div class="py-3 md:py-4"></div>
          </div>

          <!-- referrals transactions title -->
          <div class="px-5 md:px-6 pb-4">
            <div class="text-lg md:text-xl font-bold title-color">
              Recharges de vos filleules
            </div>
          </div>

          <!-- transactions list -->
          <div class="px-5 md:px-6 pb-6">
            <div class="bg-gray-50/50 rounded-2xl md:rounded-3xl p-4 md:p-6">
              <TransactionListAffiliation />
            </div>
          </div>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>
